import gql from 'graphql-tag'



export const SEE_RECENTUSER = gql`
    query seeRecentUser{
        seeRecentUser{
            channelId
            displayName
            profileImageUrl
        }
    }
`